const serviceNames = {
    rollout_pegasus: true,
    reviews_kimera: true,
    cms_service: true,
    listings_service: true,
    machine_translation_pegasus: true,
    federation_gql_pegasus: true,
    business_users_kimera: true,
    user_analytics_kimera: true,
    localization_kimera: true,
    gigs_kimera: true,
    briefs_kimera: true,
    personal_assistant_kimera_service: true,
    payments_chimera: true,
    business_projects_kimera: true,
};

export type ServiceName = keyof typeof serviceNames;

export const isValidServiceName = (serviceName: ServiceName) => Object.keys(serviceNames).includes(serviceName);
